import React, { Component } from 'react'
import { connect } from 'react-redux'
import { forgotPassword, exitForgotPassword } from '../../../redux/actions/authActions'
import TextFieldGroup from '../../common/TextFieldGroup'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/styles'
import { Theme } from '../../../utils/Theme'
import { Box, Button } from '@material-ui/core'
import AuthLayout from '../../layout/AuthLayout';

const styles = Theme()

class ForgotPassword extends Component {
  constructor(props) {
    super(props)
    this.state = {
      errors: {},
      success: false,
      email: '',
    }

    this.onChange = this.onChange.bind(this)
    this.onSubmit = this.onSubmit.bind(this)
  }

  onChange(e) {
    this.setState({ [e.target.name]: e.target.value })
  }

  onSubmit(e) {
    e.preventDefault()

    const userData = {
      email: this.state.email,      
    }

    this.props.forgotPassword(userData)
  }

  UNSAFE_componentWillReceiveProps(nextProps, nextContext) {
    if (nextProps.auth.passwordReset) {
      if (nextProps.auth.passwordReset === 'success') {
        this.setState({ success: true })
      }
    }

    if (nextProps.errors.email) {
      this.setState({ errors: nextProps.errors })
    }
  }

  render() {
    const { errors } = this.state
    const { classes, history, exitForgotPassword } = this.props
    return (
      <AuthLayout>
        <Box>
          <h4 className="u-mb-medium">Reset Password</h4>
          {this.state.success && (
            <div>
              <h5 className="u-color-secondary">
                Instructions to reset your password have been send. Please check your email to reset your password.
              </h5>

              <Button
                onClick={() => {
                  history.push('/login')
                  exitForgotPassword()
                }}
                className={`u-mt-medium c-btn ${classes.buttonPrimary}`}
              >
                Login
              </Button>
            </div>
          )}

          {!this.state.success && (
            <form noValidate onSubmit={this.onSubmit}>
              <TextFieldGroup
                label="Email Address"
                type="email"
                name="email"
                error={errors.email}
                value={this.state.email}
                onChange={this.onChange}
              />

              <Button
                onClick={this.onSubmit}
                className={`c-btn c-btn--fullwidth ${classes.buttonPrimary}`}
                varian={'contained'}
              >
                Receive a new reset Link
              </Button>
              <div className="row">
                <div className={'col-xs-12 col-sm-12 u-pt-medium'}>
                  <Button
                    className={`c-btn--fullwidth c-btn ${classes.buttonSecondary}`}
                    varian={'contained'}
                    onClick={() => this.props.history.push('/login')}
                  >
                    Cancel
                  </Button>
                </div>
              </div>
            </form>
          )}
        </Box>
      </AuthLayout>
    )
  }
}

ForgotPassword.propTypes = {
  forgotPassword: PropTypes.func.isRequired,
  auth: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
  history: PropTypes.object,
  classes: PropTypes.object,
}

const mapStateToProps = state => ({
  auth: state.auth,
  errors: state.errors,
})

export default connect(mapStateToProps, { forgotPassword, exitForgotPassword })(withStyles(styles)(ForgotPassword))
